import { render, staticRenderFns } from "./TopicReply.vue?vue&type=template&id=6d32c4f0&"
import script from "./TopicReply.vue?vue&type=script&lang=js&"
export * from "./TopicReply.vue?vue&type=script&lang=js&"
import style0 from "./TopicReply.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports